module.exports = __webpack_public_path__ + "static/karl-ake-painting-283ff5ddf15166e4657888a8f3cc3caf.jpg";